// ...imports
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPermisosall, actualizarPermisos } from '../../../redux/actions';
import styles from './Permiso.module.css';

const PermisosView = () => {
    const dispatch = useDispatch();
    const permisosRedux = useSelector(state => state.permisos);
    const [permisos, setPermisos] = useState([]);
    const [modificados, setModificados] = useState({});
    const [filtroNombre, setFiltroNombre] = useState('');
    const [loading, setLoading] = useState(true);



    useEffect(() => {
        dispatch(getPermisosall()).then(() => setLoading(false));
    }, [dispatch]);

    useEffect(() => {

        // permisosRedux.forEach(p => {
        //     console.log(`Usuario: ${p.Usuario?.nombre}, Idarea: ${p.Usuario?.Idarea}, Tipo: ${typeof p.Usuario?.Idarea}`);
        // });

        if (!permisosRedux || permisosRedux.length === 0) return; // 🔒 Espera a que haya datos

        const Idarea = parseInt(sessionStorage.getItem('Idarea'));
        const Idrol = parseInt(sessionStorage.getItem('Idrol'));
        // console.log('Idarea:', Idarea, 'Idrol:', Idrol);

        let listaFiltrada = [];
        // console.log("Idarea:", Idarea, typeof Idarea);
        // console.log("PermisosRedux:", permisosRedux);


        if (Idarea === 1 && Idrol === 1) {
            listaFiltrada = permisosRedux;
            // console.log("LIST1:", listaFiltrada)
        } else if (Idarea === 2) {
            listaFiltrada = permisosRedux.filter(p => Number(p.Usuario?.Idarea) === 2);
            // console.log("LIST2:", listaFiltrada)
        }
        // console.log("Filtrados por area:", listaFiltrada);

        // Ordenar alfabéticamente por nombre de usuario
        listaFiltrada.sort((a, b) => {
            const nombreA = (a.nombreUsuario || a.Usuario?.nombre || '').toLowerCase();
            const nombreB = (b.nombreUsuario || b.Usuario?.nombre || '').toLowerCase();
            return nombreA.localeCompare(nombreB);
        });

        setPermisos(listaFiltrada);
    }, [permisosRedux]);




    const camposPermiso = [
        'referencia', 'inbound', 'informes', 'personal', 'operaciones', 'transmuestra',
        'cyr', 'certificado','analisis', 'reftemp', 'planmuestreo', 'configuracion',
        'crear', 'consultar', 'actualizar', 'deshabilitar'
    ];

    const handleCheckboxChange = (userId, campo) => {
        setPermisos(prev =>
            prev.map(p =>
                p.Idusuario === userId
                    ? { ...p, [campo]: p[campo] === 1 ? 0 : 1 }
                    : p
            )
        );

        setModificados(prev => ({
            ...prev,
            [userId]: {
                ...(prev[userId] || {}),
                id: permisos.find(p => p.Idusuario === userId)?.id,
                [campo]: permisos.find(p => p.Idusuario === userId)?.[campo] === 1 ? 0 : 1
            }
        }));
    };

    const handleGuardarCambios = () => {
        const permisosActualizados = Object.values(modificados);
        if (permisosActualizados.length > 0) {
            dispatch(actualizarPermisos(permisosActualizados));
            alert("Cambios enviados al servidor.");
            setModificados({});
        }
    };

    const hayCambios = Object.keys(modificados).length > 0;

    if (loading) {
        return (
            <div className={styles.loaderContainer}>
                <p>Cargando datos...</p>
            </div>
        );
    }

    return (
        <div className={styles['permisos-container']}>
            <h2 className={styles['permisos-title']}>Listado de Permisos por Usuario</h2>

            <div className={styles['permisos-toolbar']}>
                <input
                    type="text"
                    placeholder="Buscar por nombre de usuario..."
                    value={filtroNombre}
                    onChange={(e) => setFiltroNombre(e.target.value)}
                    className={styles['input-busqueda']}
                />

                <button
                    onClick={handleGuardarCambios}
                    disabled={!hayCambios}
                    className={styles['guardar-button']}
                >
                    Guardar Cambios
                </button>
            </div>

            <div className={styles['permisos-table-container']}>
                <table className={styles['permisos-table']}>
                    <thead>
                        <tr>
                            <th className={styles['usuario-header']}>Nombre Usuario</th>
                            {camposPermiso.map(campo => (
                                <th key={campo} className={styles['permiso-header']}>
                                    {campo}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {permisos
                            .filter(permiso => {
                                const nombre = permiso.nombreUsuario || permiso.Usuario?.nombre || '';
                                return nombre.toLowerCase().includes(filtroNombre.toLowerCase());
                            })
                            .map((permiso, index) => (
                                <tr key={index}>
                                    <td className={styles['nombre-usuario']}>
                                        {permiso.nombreUsuario || permiso.Usuario?.nombre || 'Sin nombre'}
                                    </td>
                                    {camposPermiso.map(campo => (
                                        <td key={campo}>
                                            <input
                                                type="checkbox"
                                                checked={permiso[campo] === 1}
                                                onChange={() => handleCheckboxChange(permiso.Idusuario, campo)}
                                            />
                                        </td>
                                    ))}
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default PermisosView;
